// Imports => Dependencies
import React, {cloneElement} from 'react';
import {Props} from './ac-tab-panel.proptypes';

const AcTabPanel = ({id, component = <div />, ...rest}) => {
  return (
    <div className={'ac-tab-panel'} key={`ac-tab-panel-${id}`} id={`ac-tab-panel-${id}`} {...rest}>
      {cloneElement(component, {...rest, id})}
    </div>
  );
};

AcTabPanel.displayName = 'AcTabPanel';
AcTabPanel.propTypes = Props;

export {AcTabPanel};
export default AcTabPanel;
